export const examenPruebas = [
    {"codigo": "011M", "nombre": "Matemáticas"},
    {"codigo": "0004", "nombre": "Lectura Crítica"},
    {"codigo": "002S", "nombre": "Sociales y ciudadanas"},
    {"codigo": "0083", "nombre": "Ciencias Naturales"},
    {"codigo": "0003", "nombre": "Inglés"},
    {"codigo": "004T", "nombre": "Lectura Crítica"},
    {"codigo": "005T", "nombre": "Razonamiento Cuantitativo"},
    {"codigo": "001T", "nombre": "Competencias Ciudadanas"},
    {"codigo": "004P", "nombre": "Lectura Crítica"},
    {"codigo": "0005", "nombre": "Razonamiento Cuantitativo"},
    {"codigo": "001P", "nombre": "Competencias Ciudadanas"}
];

export const examen= [
    {"codigo": "1010", "nombre": "Saber 11"},
    {"codigo": "PRSA", "nombre": "PreSaber"},
    {"codigo": "1054", "nombre": "PreIcfes TyT"},
    {"codigo": "VALB", "nombre": "Validación del bachillerato"},
    {"codigo": "SPRO", "nombre": "Saber Pro"},
    {"codigo": "1011", "nombre": "Saber TyT"},
]